import { AuthButtons } from "./login.tsx";

const dialogOverlayClass =
  "fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs overflow-y-auto";
const dialogCardClass =
  "relative w-full max-w-md bg-surface-raised-light dark:bg-surface-raised border border-border-subtle-light dark:border-border-subtle rounded-2xl shadow-2xl p-6 sm:p-8 flex flex-col gap-4 text-left my-8";
const defaultTitle = "Add an Email to Continue";
const defaultDescription =
  "To set up a dedicated WhatsApp number, add an email to your account so you can manage your numbers and billing.";

export const UpgradeToEmailDialog = ({
  isOpen,
  onClose,
  onSuccess,
  title,
  description,
  redirectUrl,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  title?: string;
  description?: string;
  redirectUrl?: string;
}) => {
  if (!isOpen) return null;

  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <div
      className={dialogOverlayClass}
      onClick={onClose}
    >
      <div
        className={dialogCardClass}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between pb-3 border-b border-border-subtle-light dark:border-border-subtle">
          <div>
            <h2 className="text-xl font-bold text-text-primary-light dark:text-text-primary font-display flex items-center gap-2">
              <span>✉️</span> {title ?? defaultTitle}
            </h2>
            <p className="text-xs text-text-secondary-light dark:text-text-secondary mt-1">
              {description ?? defaultDescription}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-text-tertiary-light dark:text-text-tertiary hover:text-text-primary-light dark:hover:text-text-primary text-xl font-bold p-1 cursor-pointer self-start"
          >
            ✕
          </button>
        </div>

        <div className="pt-2">
          <AuthButtons
            showGuest={false}
            buttonTextPrefix="Continue"
            redirectUrl={redirectUrl}
            onSuccess={handleSuccess}
          />
        </div>
      </div>
    </div>
  );
};
